export const currencyQuery = () => {
  const query = `
    query {
      customerCurrency
    }
  `;
  return query;
};

export const updateCurrencyMutation = (currency) => {
  let mutation = `
      mutation{
          updateSettings(
              currency: ${JSON.stringify(currency)}
          ){
              company{
                  companyName
                  companyShortName
                  address
                  defaultMpesaShortcode{
                      id
                      shortcode
                      tillNumber
                      isActive
                      validatePayments
                      shortcodeType
                      defaultAccountNumber
                  }
                  includeInMessages
                  customerAccount{
                      id
                      autoGenerateRentInvoices
                      autoGenerateOtherRecurringInvoices
                      currency
                  }
                  logo{
                      id
                      file
                  }
                  letterhead{
                      id
                      file
                  }
              }
              error{
                  code
                  message
              }
          }
      }
  `
  return mutation
}